import get from 'lodash.get';
import { getPinCode, getCateringData } from '@/services/catering';
import { cateringSettingsKey, cateringDataKey } from '@/constants';
import { validateSettings } from './helpers';
import { getFromLocalCache, saveToLocalCache, removeFromLocalCache } from '@/utils/catering';

const setCateringSettings = async ({ commit }, settings) => {
  try {
    validateSettings(settings);
    await saveToLocalCache(cateringSettingsKey, settings);
    commit('UPDATE_CATERING_SETTINGS', { settings, error: null });
  } catch (e) {
    commit('UPDATE_CATERING_SETTINGS', { settings: null, error: e });
    throw new Error(e);
  }
};

const getCateringSettings = async ({ commit }) => {
  const localSettings = await getFromLocalCache(cateringSettingsKey);
  // If key does not exist
  if (!localSettings) {
    commit('UPDATE_CATERING_SETTINGS', { settings: null });
    return;
  }
  try {
    validateSettings(localSettings); // this will throw an error if invalid
    commit('UPDATE_CATERING_SETTINGS', { settings: localSettings });
  } catch (e) {
    await removeFromLocalCache(cateringSettingsKey);
    commit('UPDATE_CATERING_SETTINGS', { settings: null, error: e });
  }
};

const getRemotePinCode = async ({ commit }) => {
  const fetchResponse = await getPinCode();
  const pinCode = get(fetchResponse, 'data.pinCode');
  commit('UPDATE_LOCAL_PINCODE', { code: pinCode });
};

const getRemoteCateringData = async ({ commit }, { office, date }) => {
  const localData = await getFromLocalCache(cateringDataKey);

  const DATE_VALID = get(localData, 'date') === date;
  // First check if the data is already stored locally
  if (localData && DATE_VALID) {
    commit('UPDATE_CATERING_DATA', localData);
  } else {
    const fetchResponse = await getCateringData({ office, date });
    const cateringData = { ...get(fetchResponse, 'data.getCateringData'), date };
    await saveToLocalCache(cateringDataKey, cateringData);
    commit('UPDATE_CATERING_DATA', cateringData);
  }
};

const checkLocalUserOrder = async ({ commit }, { userId, orderId, served }) => {
  const localData = await getFromLocalCache(cateringDataKey);
  const users = get(localData, 'users');
  const foundUserIndex = users.findIndex((user) => user.id === userId);
  const currentUser = users[foundUserIndex];
  const userOrders = get(currentUser, 'orders');
  const meals = Object.keys(userOrders);

  // Find correct order and update it
  meals.forEach((meal) => {
    const order = userOrders[meal];
    if (order && order.id === orderId) {
      order.served = served;
    }
  });

  // Save it in local and in the store
  await saveToLocalCache(cateringDataKey, localData);
  commit('UPDATE_CATERING_DATA', localData);
};

export default {
  setCateringSettings,
  getCateringSettings,
  getRemotePinCode,
  getRemoteCateringData,
  checkLocalUserOrder,
};



// WEBPACK FOOTER //
// ./store/modules/catering/actions.js